import { useTranslation } from 'react-i18next';
import { NAMESPACES } from './config';

/**
 * `useTranslation` bound to every namespace.
 *
 * The reason to prefer this over calling `useTranslation()` directly: with no
 * namespace argument, i18next's types only accept keys from the default one,
 * so `t('errors:notFound.title')` is a type error and the fix people reach for
 * is to widen the augmentation until nothing is checked at all.
 *
 * Binding all four instead keeps keys fully qualified and checked. It costs
 * nothing at runtime — every catalogue is already in the bundle — and it makes
 * the namespace visible at each call site, which matters when the same word
 * ("Close", "Air") means different things in different namespaces.
 */
export function useT() {
  return useTranslation([...NAMESPACES]);
}
